import produce from 'immer';
import { handleActions } from 'redux-actions';
import actions from './actions';
import {
  NOTICE_PRODUCT_INFO_MODEL,
  NOTICE_PRODUCT_LIST_FILTER_OPTION_MODEL,
  NOTICE_PRODUCT_LIST_SORT_OPTION_MODEL,
} from './models';
import { LIST_PAGINATION_MODEL } from '../../app/models';
import { updateStoreWithPath } from '../../../../lib/common';

/**
 *  INITIAL STATE
 */
const initialState = {
  /**
   *  상품 공지사항 리스트 MODEL
   */
  noticeProductList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  필터 옵션
     */
    filterOption: NOTICE_PRODUCT_LIST_FILTER_OPTION_MODEL,
    /**
     *  정렬 옵션 리스트
     */
    sortOption: NOTICE_PRODUCT_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: {
      totalCnt: null,
    },
  },

  /**
   *  상품 공지사항 상세에서 사용되는 MODEL
   */
  noticeProductDetail: {
    /**
     *  상품 공지사항 기본 정보
     */
    info: NOTICE_PRODUCT_INFO_MODEL,
    /**
     *  상품 공지사항에 등록된 상품 리스트
     */
    itemListInfo: {
      list: [],
      /**
       *  리스트 pagination
       */
      pagination: LIST_PAGINATION_MODEL,
      /**
       *  집계 데이터
       */
      summary: {
        totalCnt: null,
      },
    },
  },
};

/**
 *  REDUCER
 */
export default handleActions(
  {
    /**
     *  [상품 공지사항] 상품 공지사항 데이터 변경하기
     */
    [actions.SET_DATA]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath(action.payload.path, action.payload.value, draft);
      });
    },

    /**
     *  [상품 공지사항 리스트] 상품 공지사항 리스트 가져오기
     */
    [actions.GET_NOTICE_PRODUCT_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 공지사항 리스트
         */
        draft.noticeProductList = action.payload.noticeProductList;
      });
    },

    /**
     *  [상품 공지사항 상세] 상품 공지사항 상세 데이터 요청하기
     */
    [actions.GET_NOTICE_PRODUCT_INFO_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 공지사항 기본 정보
         */
        draft.noticeProductDetail.info = action.payload.noticeProductInfo;
        draft.noticeProductDetail.itemListInfo = action.payload.noticeProductItemListInfo;
      });
    },

    /**
     *  [상품 공지사항 상세] 상품 공지사항에 등록된 상품 목록 구하기
     */
    [actions.GET_NOTICE_PRODUCT_ITEM_INFO_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 공지사항 기본 정보
         */
        draft.noticeProductDetail.itemListInfo = action.payload.noticeProductItemListInfo;
      });
    },
  },
  initialState,
);
